<div class="trip-detail-popup-right">
  <img
    src="../../../assets/img/icons8-macos-close-60.png"
    class="close-icons"
    (click)="close()"
  />
</div>
<form class="admin-forms" [formGroup]="addRoutesForm">
  <div class="accordion-class">
    <h5>Add</h5>
    <mat-divider></mat-divider>
    <div class="row mt-2">
      <div class="row mt-2">
        <div class="col-sm-12 d-flex align-items-center gap-3 radio">
          <div class="form-check">
            <mat-radio-group
              class="radio_group"
              aria-label="Select an option"
              [value]="selectedOption"
              (change)="onRadioChange($event)"
            >
              <mat-radio-button style="margin-right: 30px" value="1"
                >Routes</mat-radio-button
              >
              <mat-radio-button value="2">Pickup City</mat-radio-button>
            </mat-radio-group>
            <!-- <label class="form-check-label" for="routesRadio">Routes</label> -->
          </div>
        </div>
      </div>

      <div class="col-sm-12 d-flex align-items-center">
        <div class="add_routes">
          <mat-form-field
            class="no-error-underline add_routes_location example-full-width"
            appearance="fill"
          >
            <div class="inner-container">
              <img
                class="location"
                src="../../../assets/img/location_icon.svg"
                alt=""
              />

              <input
                matInput
                formControlName="pickup_city"
                placeholder="Pickup City"
                (change)="onInputPickUpchange()"
                #pickUpLocationSearchField
                required
              />
            </div>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row mt-2" *ngIf="selectedOption != '2'">
      <div class="col-sm-12 d-flex align-items-center">
        <div class="add_routes">
          <mat-form-field
            class="no-error-underline add_routes_location"
            appearance="fill"
          >
            <div style="display: flex; gap: 10px">
              <img
                class="location"
                src="../../../assets/img/location_icon.svg"
                alt=""
              />

              <input
                matInput
                placeholder="Dropoff City"
                formControlName="dropoff_city"
                (change)="onDropChange()"
                #dropLocationSearchField
                required
              />
            </div>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-sm-12 d-flex align-items-center">
        <div class="add_routes">
          <mat-form-field
            class="no-error-underline add_routes_location"
            appearance="fill"
          >
            <mat-select
              placeholder="Select Truck Category"
              formControlName="truck_category"
            >
              <mat-option *ngFor="let cat of truckCategory" [value]="cat._id">
                {{ cat.truck_category_name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12 d-flex align-items-center justify-content-center">
        <button
          type="button"
          class="button buttonCancel my-3"
          [disabled]="!addRoutesForm.valid"
          (click)="addRoute()"
        >
          Submit
        </button>
      </div>
    </div>
  </div>
</form>
